import styled from 'styled-components';

const Container = styled.div`
  margin: 15px 30px;
  padding: 10px;
  ${(props) => props.stick && 'margin: 0'}
`;

export default Container;



// WEBPACK FOOTER //
// ./components/layout/Container.js